export enum ReportsIdEnum {
  driver_termns_and_conditions = 287,
  billing_invoice_payor = 280,
  billing_mct_invoice_batch = 267,
  billing_unveried_trips = 304,
  billing_unveried_trips_audit = 305,
  billing_unveried_ar_summary = 307,
  billing_invoice_general = 268,
  driver_manifest = 1419,
  vehicle_inspection = 1446,
  ambulance_invoices = 1522,
  trip_billing = 1528,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/reportsId.enum.ts